<template>
  <Modal :value="value" @hide="hide()" title="Assign role">
    <template slot="body" class="content">
      <p class="">Assign the <i>Global admin</i> role to a user account.</p>

      <div class="margin-bottom-1">
        <BInput
          @valid="valid = $event"
          v-model="email"
          type="email"
          validation="required"
          placeholder="User email"
          name="email"
          focus="true"
          @enter="save()"
        ></BInput>
      </div>
    </template>
    <template slot="footer" class="content">
      <div v-if="!isLoading">
        <div
          @click="save()"
          :disabled="!valid"
          class="button is-success"
          :class="{ 'is-loading': isLoading }"
        >
          Save
        </div>
        <div class="button" @click="hide()">Cancel</div>
      </div>
      <div v-show="isLoading" class="spinner-wrapper center">
        <span class="spinner is-centered"></span>
      </div>
    </template>
  </Modal>
</template>
<script>
import { focus, getId } from "@/utils/document";
import { postApi } from "@/utils/http";

export default {
  props: {
    value: Boolean,
    title: String,
  },
  components: {
    Modal: () => import("@/components/main/Modal.vue"),
    BInput: () => import("@/components/singles/BInput/component.vue"),
    CheckboxText: () => import("@/components/singles/CheckboxText.vue"),
  },
  data() {
    return {
      email: "",
      isLoading: false,
      valid: false,
    };
  },
  computed: {},
  created() {},

  methods: {
    async save() {
      this.isLoading = true;
      const res = await postApi("set/userRole", {
        mail: this.email.trim().toLowerCase(),
        level: 0,
      });

      this.isLoading = false;

      if (res.length !== 0) {
        this.$emit("change", res[0]);
        this.hide();
      } else {
        this.$helpers.notify(
          "Not found",
          "The user does not exist.",
          "warning"
        );
      }
    },

    hide() {
      if (!this.isLoading) {
        this.$emit("hide", false);
        this.$emit("input", false);
      }
    },
  },
};
</script>
